import AtcFlightGroupDaysShiftArrivalModule from './flight-group-days-shift-arrival/flight-group-days-shift-arrival-module';
import AtcFlightGroup from './flight-group-component';
import AtcFlightGroupService from './flight-group-service';
import './flight-group.scss';

const MODULE_NAME = 'app.atc.flight.segment.group';
const module = angular.module(MODULE_NAME, [
        AtcFlightGroupDaysShiftArrivalModule,
    ])
    .directive(AtcFlightGroup.DIRECTIVE_NAME, AtcFlightGroup)
    .service('atcFlightGroupService', AtcFlightGroupService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-group/flight-group-module.js